import {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";

import {buildUploadFormData} from "../lib/build-upload-form-data";
import {FileCreateRequest, FileCreateResponse} from "../types";

class FilesApi extends CoreApi {
  createFiles({
    files,
    upload_context,
    task_id,
    phase_key,
  }: FileCreateRequest): Promise<AxiosResponse<FileCreateResponse>> {
    return super.create(
      "files",
      buildUploadFormData(files, {upload_context, task_id, phase_key}),
    );
  }
}

export const filesApi = new FilesApi();
